<template>
  <!-- 로그인 뒤 탭·세션당 한 번: 6개월마다 운영자 계정 권한 확인(T-CONTRACT-1031 §2). 규칙은 utils/permReview.js -->
  <a-modal :open="open" :footer="null" width="720px" :mask-closable="false" @cancel="later">
    <template #title>
      <div class="modal-title">{{ REVIEW_TITLE }}</div>
    </template>
    <div class="modal-content">
      <p class="hint">{{ REVIEW_HINT }}</p>
      <p class="sub-text">{{ lastReviewText(status) }}</p>
      <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="{ pageSize: 10, hideOnSinglePage: true }"
        :scroll="{ x: 600 }"
        row-key="key"
        size="small"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'lastLogin'">
            <span class="nowrap">{{ record.lastLogin }}</span>
            <a-tag v-if="record.inactive" color="orange" class="ms-1">90일 넘게 안 씀</a-tag>
          </template>
        </template>
      </a-table>
      <div class="modal-footer">
        <a-button :disabled="saving" @click="later">나중에</a-button>
        <a-button type="primary" class="yellow-button" :loading="saving" @click="confirm">확인했어요</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  REVIEW_HINT,
  REVIEW_TITLE,
  alreadyAsked,
  lastReviewText,
  loadDueStatus,
  markAsked,
  reviewBody,
  staffRows,
} from "@/utils/permReview";
import { PermReviewApi } from "@/api/standards";

export default {
  name: "PermReviewModal",
  data() {
    return {
      REVIEW_HINT,
      REVIEW_TITLE,
      lastReviewText,
      open: false,
      status: null,
      saving: false,
      columns: [
        { key: "name", dataIndex: "name", title: "이름", width: 110 },
        { key: "username", dataIndex: "username", title: "아이디", width: 130 },
        { key: "menus", dataIndex: "menus", title: "켜진 메뉴" },
        { key: "lastLogin", title: "마지막 로그인", width: 230 },
      ],
    };
  },
  computed: {
    rows() {
      return staffRows(this.status);
    },
  },
  watch: {
    // 로그인 뒤 첫 이동에서 권한 값(introspect)을 받으면 한 번 묻는다. 로그아웃(null)이면 창·목록을 지움
    "$store.state.introspect": {
      immediate: true,
      handler(v) {
        if (v) this.check();
        else this.clear();
      },
    },
  },
  methods: {
    async check() {
      if (!localStorage.getItem("accessTokenCerti") || alreadyAsked(sessionStorage)) return;
      markAsked(sessionStorage); // 실패해도 이 탭에선 다시 부르지 않음
      try {
        // 요청 중 로그아웃·다른 계정 로그인이면 응답을 버림
        const status = await loadDueStatus(PermReviewApi.status, () => localStorage.getItem("accessTokenCerti"));
        if (!status) return;
        this.status = status;
        this.open = true;
      } catch (error) {
        // 조용히 넘어감(알림 금지)
        console.error(error);
      }
    },
    clear() {
      this.open = false;
      this.status = null;
    },
    later() {
      if (this.saving) return;
      this.open = false;
    },
    async confirm() {
      this.saving = true;
      try {
        await PermReviewApi.record(reviewBody(this.status));
      } catch (error) {
        // 기록 실패도 조용히 닫음 — 다음 로그인 때 서버가 다시 due 를 줌
        console.error(error);
      } finally {
        this.saving = false;
        this.open = false;
      }
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 0 0 6px;
  font-size: 13px;
  color: #2f3337;
  word-break: keep-all;
}
.sub-text {
  margin: 0 0 10px;
  font-size: 12px;
  color: #5c6168;
}
.nowrap {
  white-space: nowrap;
}
/* 창 본문 여백(레포 규칙 src/modal.mdc — 전역 .modal-content 테두리·.ant-modal-content padding 0 을 덮음, FIX-1101 12) */
.modal-content {
  padding: 20px;
  border: none;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
.modal-footer :deep(.yellow-button) {
  background-color: #ffcc32 !important;
  border-color: #ffcc32 !important;
  color: #000 !important;
}
</style>
